module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "fade-in",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('div', {
    key: "alert",
    class: ("alert alert-" + _vm.type + " " + _vm.alertClass),
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconClass),
      expression: "iconClass"
    }],
    class: ("icon " + _vm.iconClass),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._t("default")], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0a400259!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Alert.vue
// module id = 504
// module chunks = 1